export * from './lib/order-detail-layout.module';
export * from './lib/lib.routes';

export * from './lib/order-detail/order-detail.component';
export * from './lib/order-detail/left-panel/left-panel.component';
